import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  chip: {
    width: '100%',
    color: 'white',
    backgroundColor: ({ isSelected }) => (isSelected ? '#1a7992' : '#9b9b9b'),
    '&:hover': {
      backgroundColor: '#65a3b5',
    },
    '&:focus': {
      backgroundColor: ({ isSelected }) => (isSelected ? '#1a7992' : '#9b9b9b'),
    },
  },
}));
